import React from "react";
import CitySocial from "./city-social";
import { useEffect, useState } from "react";

const calculateTimeLeft = (raceTime) => {
  const difference = +raceTime - +new Date();
  let timeLeft = {};

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  return timeLeft;
};

export default function CountdownCta({
  city,
  nav,
  hideSocials,
  showSeconds = false,
}) {
  const [showCountdownCta, setShowCountdownCta] = useState(false);
  const [timeLeft, setTimeLeft] = useState();

  useEffect(() => {
    if (city?.countdownTo) {
      const raceTime = new Date(city.countdownTo);
      const currentDate = new Date();

      setShowCountdownCta(raceTime > currentDate);
      setTimeLeft(calculateTimeLeft(raceTime));

      setInterval(() => {
        setTimeLeft(calculateTimeLeft(raceTime));
      }, 1000);
    }
  }, [city?.countdownTo]);

  return showCountdownCta ? (
    <>
      <div
        className={`d-flex w-100 ${hideSocials ? " socials-register-container d-flex d-lg-none justify-content-between align-items-end align-items-lg-center" : "d-none d-lg-flex justiy-content-end align-items-center main-nav-bar w-auto"}`}
      >
        <div
          className={`${nav ? "d-none d-lg-block" : "d-block d-lg-none"} countdown-cta `}
        >
          <span className="countdown-label">{city.countdownLabel}</span>
          {timeLeft.hours || timeLeft.minutes || timeLeft.seconds ? (
            <div className="countdown-inner">
              <span>
                {timeLeft.days}
                <span className="affix">DAYS</span>
              </span>
              <span>
                {timeLeft.hours}
                <span className="affix">H</span>
              </span>
              <span>
                {timeLeft.minutes}
                <span className="affix">MIN</span>
              </span>
              {showSeconds && (
                <span>
                  {timeLeft.seconds}
                  <span className="affix">S</span>
                </span>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>

        <div
          className={`socials-register-container-inner ${nav ? "d-none d-lg-flex" : "d-flex d-lg-none"} justify-content-lg-between`}
        >
          {!hideSocials && (
            <div className={`socials ${nav ? "d-lg-none" : ""}`}>
              <CitySocial city={city} />
            </div>
          )}
          {city.countdownCtaText && (
            <div className="register-btn-container">
              <a
                href={city.countdownCtaUrl}
                target="_blank"
                rel="noreferrer"
                aria-label="Countdown CTA"
                className="btn btn-primary"
              >
                {city.countdownCtaText}
              </a>
            </div>
          )}
        </div>
      </div>
    </>
  ) : (
    <></>
  );
}
